"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseYoutubeChannel = void 0;
var tslib_1 = require("tslib");
var url_types_1 = require("@wix/wix-vod-constants/dist/common/url-types");
var objectUtils = tslib_1.__importStar(require("@wix/wix-vod-shared/dist/src/common/utils/object"));
var channel_types_1 = require("@wix/wix-vod-constants/dist/common/channel-types");
var get_thumbnail_1 = tslib_1.__importDefault(require("./get-thumbnail"));
function parseYoutubeChannel(urlType, channelData) {
    var externalId = channelData.id, _a = channelData.snippet, snippet = _a === void 0 ? {} : _a, _b = channelData.contentDetails, contentDetails = _b === void 0 ? {} : _b, _c = channelData.statistics, statistics = _c === void 0 ? {} : _c, _d = channelData.brandingSettings, brandingSettings = _d === void 0 ? {} : _d, _e = channelData.isExternalRemoved, isExternalRemoved = _e === void 0 ? false : _e;
    var title = snippet.title, description = snippet.description, thumbnails = snippet.thumbnails, publishedAt = snippet.publishedAt;
    var itemCount = contentDetails.itemCount, _f = contentDetails.relatedPlaylists, relatedPlaylists = _f === void 0 ? {} : _f;
    var videosCount = Number(itemCount || statistics.videoCount) || 0;
    var thumbnailUrl = (0, get_thumbnail_1.default)(thumbnails) || null;
    var coverUrl = _.get(brandingSettings, 'image.bannerTvImageUrl') || thumbnailUrl;
    if (urlType === url_types_1.URL_TYPES.PLAYLIST && videosCount === 0) {
        coverUrl = null;
    }
    return objectUtils.removeUndefinedValues({
        externalId: externalId,
        uploadsPlaylistId: relatedPlaylists.uploads,
        title: title,
        description: description,
        thumbnailUrl: thumbnailUrl,
        coverUrl: coverUrl,
        videosCount: videosCount,
        externalCreatedTs: new Date(publishedAt),
        channelType: channel_types_1.CHANNEL_TYPES.YOUTUBE_FEED,
        urlType: urlType,
        isExternalRemoved: isExternalRemoved,
    });
}
exports.parseYoutubeChannel = parseYoutubeChannel;
//# sourceMappingURL=channel.js.map